<template>
  <div class="signature">
    <div class="signatureBox">
      <div class="canvasBox" ref="canvasHW">
        <canvas
          ref="canvasF"
          @touchstart="touchStart"
          @touchmove="touchMove"
          @touchend="touchEnd"
          @mousedown="mouseDown"
          @mousemove="mouseMove"
          @mouseup="mouseUp"
          width="600"
          height="340"
        ></canvas>
      </div>
    </div>
    <div
      style="
        display: flex;
        width: 100%;
        flex-direction: row;
        justify-content: space-around;
        padding-top: 5px;
      "
    >
      <!-- <el-button type="info" size="small">取消</el-button> -->
      <el-button @click="overwrite" size="small">清除</el-button>
      <el-button type="primary" @click="commit" size="small">确定</el-button>
    </div>
  </div>
</template>
<script>
import * as dfsApi from '../../api/dfsApi'

export default {
  props: {
    item: {
      type: Object,
      default: function () {
        return {}
      },
      // default: {}
    },
  },
  data() {
    return {
      stageInfo: '',
      imgUrl: '',
      file: '',
      client: {},
      points: [],
      canvasTxt: null,
      startX: 0,
      startY: 0,
      moveY: 0,
      moveX: 0,
      endY: 0,
      endX: 0,
      w: null,
      h: null,
      isDown: false,
      formWhere: '',
    }
  },
  mounted() {
    this.formWhere = this.$route.query.form
    let canvas = this.$refs.canvasF
    if (this.formWhere == 'pc') {
      canvas.height = this.$refs.canvasHW.offsetHeight - 0
      canvas.width = this.$refs.canvasHW.offsetWidth - 0
    } else {
      if (
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
      ) {
        canvas.height = window.screen.height / 2 - 0
        canvas.width = window.screen.width - 0
      } else {
        canvas.height = this.$refs.canvasHW.offsetHeight - 0
        canvas.width = this.$refs.canvasHW.offsetWidth - 0
      }
    }
    this.canvasTxt = canvas.getContext('2d')
    this.stageInfo = canvas.getBoundingClientRect()
  },
  methods: {
    draw(x, y, isDown) {
      if (isDown) {
        this.canvasTxt.beginPath()
        this.canvasTxt.strokeStyle = '#000' // 颜色
        this.canvasTxt.lineWidth = 3 // 线宽
        this.canvasTxt.lineJoin = 'round'
        this.canvasTxt.lineMax = 10 // 设置画笔最大线宽
        this.canvasTxt.lineMin = 3 // 设置画笔最小线宽
        this.canvasTxt.linePressure = 1.2 // 设置画笔笔触压力
        this.canvasTxt.smoothness = 30 // 设置画笔笔触大小变化的平滑度
        this.canvasTxt.moveTo(this.startX, this.startY)
        this.canvasTxt.lineTo(x, y)
        this.canvasTxt.closePath()
        this.canvasTxt.stroke()
      }
      this.startX = x
      this.startY = y
    },
    //mobile
    touchStart(ev) {
      ev = ev || event
      ev.preventDefault()
      if (ev.touches.length == 1) {
        let obj = {
          x: ev.targetTouches[0].clienX,
          y: ev.targetTouches[0].clientY,
        }
        this.startX = obj.x
        this.startY = obj.y
        this.draw(obj.x, obj.y, false)
        this.points.push(obj)
      }
    },
    touchMove(ev) {
      ev = ev || event
      ev.preventDefault()
      if (ev.touches.length == 1) {
        let obj = {
          x: ev.targetTouches[0].clientX - this.stageInfo.left,
          y: ev.targetTouches[0].clientY - this.stageInfo.top,
        }
        this.moveY = obj.y
        this.moveX = obj.x
        this.draw(obj.x, obj.y, true)
        this.points.push(obj)
      }
    },
    touchEnd(ev) {
      ev = ev || event
      ev.preventDefault()
      if (ev.touches.length == 1) {
        let obj = {
          x: ev.targetTouches[0].clientX - this.stageInfo.left,
          y: ev.targetTouches[0].clientY - this.stageInfo.top,
        }
        this.draw(obj.x, obj.y, false)
        this.points.push(obj)
      }
    },
    //pc
    mouseDown(ev) {
      ev = ev || event
      ev.preventDefault()
      if (1) {
        let obj = {
          x: ev.offsetX,
          y: ev.offsetY,
        }
        this.startX = obj.x
        this.startY = obj.y
        this.draw(obj.x, obj.y, false)
        this.points.push(obj)
        this.isDown = true
      }
    },
    mouseMove(ev) {
      ev = ev || event
      ev.preventDefault()
      if (this.isDown) {
        let obj = {
          x: ev.offsetX,
          y: ev.offsetY,
        }
        this.moveY = obj.y
        this.moveX = obj.x
        this.draw(obj.x, obj.y, true)
        this.points.push(obj)
      }
    },
    mouseUp(ev) {
      ev = ev || event
      ev.preventDefault()
      if (1) {
        let obj = {
          x: ev.offsetX,
          y: ev.offsetY,
        }
        this.draw(obj.x, obj.y, false)
        this.points.push(obj)
        this.points.push({ x: -1, y: -1 })
        this.isDown = false
      }
    },
    //重写
    overwrite() {
      this.canvasTxt.clearRect(
        0,
        0,
        this.$refs.canvasF.width,
        this.$refs.canvasF.height
      )
      this.points = []
    },
    isCanvasBlank() {
      let blank = document.createElement('canvas') //系统获取一个空canvas对象
      blank.width = this.$refs.canvasF.width
      blank.height = this.$refs.canvasF.height
      return this.$refs.canvasF.toDataURL() == blank.toDataURL() //比较值相等则为空
    },
    //提交签名
    commit() {
      if (this.isCanvasBlank()) {
        this.$message.warning('请在空白处签名')
        return
      }
      this.file = new File(
        [this.convertBase64ToBlob(this.$refs.canvasF.toDataURL())],
        'anonymous.png'
      )
      dfsApi
        .upload('eip-mapp-oa-server', '流程表单', '签名', this.file)
        .then((res) => {
          if (this.formWhere == 'pc') {
            window.parent.curVue.signCallback(res, null)
          } else {
            this.$emit('commit', res, this.item)
          }
        })
        .catch((e) => {
          console.error(e)
          this.$message.error('网路异常')
        })
    },
    convertBase64ToBlob(base64) {
      var base64Arr = base64.split(',')
      var imgtype = ''
      var base64String = ''
      if (base64Arr.length > 1) {
        // 如果是图片base64，去掉头信息
        base64String = base64Arr[1]
        imgtype = base64Arr[0].substring(
          base64Arr[0].indexOf(':') + 1,
          base64Arr[0].indexOf(';')
        )
      }
      // 将base64解码，atob() 方法用于解码使用 base-64 编码的字符串。
      var bytes = atob(base64String)
      var bytesCode = new ArrayBuffer(bytes.length)
      // 转换为类型化数组
      var byteArray = new Uint8Array(bytesCode)
      // 将base64转换为ascii码
      for (var i = 0; i < bytes.length; i++) {
        byteArray[i] = bytes.charCodeAt(i)
      }
      console.log(imgtype)
      // 生成Blob对象（文件对象）
      return new Blob([bytesCode], { type: imgtype })
    },
  },
}
</script>
<style scoped>
.signatureBox {
  text-align: center;
}
.canvasBox {
  text-align: center;
}
canvas {
  box-shadow: #cca7a7 0px 0px 10px;
  border-radius: 9px;
  position: relative;
}
h2.sig-title {
  font-size: 30px;
}
.sig-btn {
  margin-top: 50px;
  display: none;
}
</style>
